import React, { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { useAuth } from '../../contexts/auth'
import './auth.scss'

function VerifyEmail() {
	const { verifyEmail }  = useAuth()
	const [searchParams]   = useSearchParams()
	const token            = searchParams.get('token') || ''

	const [message, setMessage] = useState('')
	const [error, setError]     = useState('')

	useEffect(() => {
		if (!token) { setError('Missing verification token.'); return }
		verifyEmail(token)
			.then(msg => setMessage(msg))
			.catch(err => setError(err.message))
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<div className='authPage'>
			<div className='authCard'>
				<h2>Email verification</h2>
				{!message && !error && <p>Verifying…</p>}
				{message && <div className='authSuccess'>{message}</div>}
				{error   && <div className='authError'>{error}</div>}
				<div className='authLinks'>
					<Link to='/login'>Go to login</Link>
				</div>
			</div>
		</div>
	)
}

export default VerifyEmail
